import { connect } from "react-redux";
import FindButtonsPanel from "./FindButtonsPanel";

const mapStateToProps = state => ({
  from: state.routeRequest.from,
  to: state.routeRequest.to,
});

export default connect(mapStateToProps)(FindButtonsPanel);
